import * as d3 from "./d3"

export function legend({
  color,
  title,
  tickSize = 6,
  width = 320,
  height = 44 + tickSize,
  marginTop = 18,
  marginRight = 0,
  marginBottom = 16 + tickSize,
  marginLeft = 0,
  ticks = width / 64,
  tickFormat,
  tickValues
} = {}) {

  const glegend = d3.create("g").attr("class", "legend")

  let tickAdjust = g => g.selectAll(".tick line").attr("y1", marginTop + marginBottom - height);
  let x;
  // Threshold
  const thresholds
      = color.thresholds ? color.thresholds() // scaleQuantize
      : color.quantiles ? color.quantiles() // scaleQuantile
      : color.domain(); // scaleThreshold

  const thresholdFormat
      = tickFormat === undefined ? d => d
      : typeof tickFormat === "string" ? d3.format(tickFormat)
      : tickFormat;

  x = d3.scaleLinear()
      .domain([-1, color.range().length - 1])
      .rangeRound([marginLeft, width - marginRight]);

  glegend.append("g")
    .selectAll("rect")
    .data(color.range())
    .join("rect")
      .attr("x", (d, i) => x(i - 1))
      .attr("y", marginTop)
      .attr("width", (d, i) => x(i) - x(i - 1))
      .attr("height", height - marginTop - marginBottom)
      .attr("fill", d => d);

  tickValues = d3.range(thresholds.length);
  tickFormat = i => thresholdFormat(thresholds[i], i);

  glegend.append("g")
    .attr("transform", `translate(0,${height - marginBottom})`)
    .attr("class", "legend-axis")
    .call(d3.axisBottom(x)
      .ticks(ticks, typeof tickFormat === "string" ? tickFormat : undefined)
      .tickFormat(typeof tickFormat === "function" ? tickFormat : undefined)
      .tickSize(tickSize)
      .tickValues(tickValues))
    .call(tickAdjust)
    .call(g => g.select(".domain").remove())
    .call(g => g.append("text")
      .attr("x", width - marginRight)
      .attr("y", marginTop + marginBottom - height - 6)
      .attr("fill", "currentColor")
      .attr("text-anchor", "end")
      .attr("font-weight", "bold")
      .text(title));

  return glegend;
}
